import { useEffect } from 'react';
import type { Address } from 'src/apis/contract-management/types';
import { useAxios } from 'src/hooks/use-axios';

export function useShipperAddress({ url }: { url?: string }) {
  const shipperAddress = useAxios(
    (axios, baseConfig, { url }: { url: string }) =>
      axios.request<Address>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!url) return;
    shipperAddress.execute({ url });
    // oxlint-disable-next-line exhaustive-deps
  }, [url]);

  if (!url) return;

  return shipperAddress;
}

export type ShipperAddressRequest = ReturnType<typeof useShipperAddress>;
